import { render, staticRenderFns } from "./RulesArchive.vue?vue&type=template&id=a44acb3a"
import script from "./RulesArchive.vue?vue&type=script&lang=ts"
export * from "./RulesArchive.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports